/**
 * SelectionScreen — Retreat duration picker.
 *
 * M2-UX-P0-007: Build SelectionScreen — retreat duration picker.
 * UI-INV-005: Leaf component, props only, no engine imports.
 */
import type { EditableRetreatSchedule } from "@retreat/core";
import type { RetreatOption } from "../bridge/types";
import { MetaStrip } from "../components/MetaStrip";
import styles from "./SelectionScreen.module.css";
import { TEST_IDS } from "../testing/testIds";

type Props = {
  options: RetreatOption[];
  onSelect: (schedule: EditableRetreatSchedule) => void;
  onStartNow: (schedule: EditableRetreatSchedule) => void;
  onCancel: () => void;
  onBrowseAll?: () => void;
};

export function SelectionScreen({
  options,
  onSelect,
  onStartNow,
  onCancel,
  onBrowseAll,
}: Props) {
  return (
    <div className={styles.screen} data-testid={TEST_IDS.SELECTION_SCREEN}>
      <MetaStrip label="Choose a retreat" onBack={onCancel} />

      <div className={styles.content}>
        <h1 className={styles.heading}>How long will you sit?</h1>

        <div className={styles.list}>
          {options.map((opt, i) => (
            <div
              key={opt.schedule.id}
              className={`${styles.optionGroup} ${i === options.length - 1 ? styles.optionGroupLast : ""}`}
            >
              <div className={styles.optionInfo}>
                <div className={styles.optionLabel}>{opt.label}</div>
                <div className={styles.optionDesc}>{opt.description}</div>
              </div>
              <div className={styles.optionActions}>
                <button
                  id={`selection-start-now-${i}`}
                  className={`${styles.actionBtn} ${styles.actionBtnNow}`}
                  onClick={() => onStartNow(opt.schedule)}
                  type="button"
                >
                  Start now
                </button>
                <button
                  id={`selection-schedule-${i}`}
                  className={`${styles.actionBtn} ${styles.actionBtnSchedule}`}
                  onClick={() => onSelect(opt.schedule)}
                  type="button"
                >
                  Schedule
                </button>
              </div>
            </div>
          ))}
        </div>

        {onBrowseAll && (
          <div className={styles.browseRow}>
            <button
              className={styles.browseLink}
              onClick={onBrowseAll}
              type="button"
              data-testid={TEST_IDS.SELECTION_BROWSE_ALL_BTN}
            >
              Browse all traditions
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
